/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetCustomerResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getCustomer = (request: GetCustomerRequest, options?: CashRequestOptions) => post<GetCustomerRequest, GetCustomerResponse>("/2.0/cash/get-customer", request, {...options, rejectOnError: true })